var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRankingSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.6 105.4C170.1 92.9 149.8 92.9 137.3 105.4L41.3 201.4C28.8 213.9 28.8 234.2 41.3 246.7C53.8 259.2 74.1 259.2 86.6 246.7L128 205.3L128 512C128 529.7 142.3 544 160 544C177.7 544 192 529.7 192 512L192 205.3L233.4 246.7C245.9 259.2 266.2 259.2 278.7 246.7C291.2 234.2 291.2 213.9 278.7 201.4L182.7 105.4zM352 544L384 544C401.7 544 416 529.7 416 512C416 494.3 401.7 480 384 480L352 480C334.3 480 320 494.3 320 512C320 529.7 334.3 544 352 544zM352 416L448 416C465.7 416 480 401.7 480 384C480 366.3 465.7 352 448 352L352 352C334.3 352 320 366.3 320 384C320 401.7 334.3 416 352 416zM352 288L512 288C529.7 288 544 273.7 544 256C544 238.3 529.7 224 512 224L352 224C334.3 224 320 238.3 320 256C320 273.7 334.3 288 352 288zM352 160L576 160C593.7 160 608 145.7 608 128C608 110.3 593.7 96 576 96L352 96C334.3 96 320 110.3 320 128C320 145.7 334.3 160 352 160z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankingSortAscending);
export default __webpack_public_path__ + "static/media/icon_ranking_sort_ascending.778194eb8689b47a3ff79133c24b9d92.svg";
export { ForwardRef as ReactComponent };